import { ILocalRepository } from "modules/auth/application/interfaces/repository/ILocalRepository";
import { SystemIdentifier } from "modules/local/domain/enums/SystemIdentifier";
import { ILocal } from "modules/local/domain/models/ILocal";

export const LocalRepository = (): ILocalRepository => {

  const localKey = "@locals";
  const auth = "@auth";
  const currentLocalkey = "@localCurrent";
  const currentCurrencyKey = "@localCurrency";

  const setLocals = (local: ILocal[]) => {
    //localStorage.setItem(localKey, JSON.stringify(local));
  };
  const getLocals = (): ILocal[] | null => {
    try {
      //const dataString = localStorage.getItem(localKey)

      const dataString = localStorage.getItem(auth);
      if (dataString) {
        const authData = JSON.parse(dataString);
        //const response = JSON.parse(dataString) as ILocal[];
        return authData?.user?.locals || null; // Recupera `locals` se estiver presente no authData
      }
      return null;
    } catch (error) {
      return null
    }
  };
  const removeLocals = () => {
    localStorage.removeItem(localKey);
  };



  const setCurrentLocal = (local: ILocal) => {
    localStorage.setItem(currentLocalkey, JSON.stringify(local));
  };
  const getCurrentLocal = (): ILocal | null => {
    try {
      const dataString = localStorage.getItem(currentLocalkey);
      if(dataString){
        const response = JSON.parse(dataString) as ILocal;
        return response;
      }else{
        return null
      }
    } catch(error) {
      console.error(error);
      return null
    }
  };
  const removeCurrentLocal = () => {
    localStorage.removeItem(currentLocalkey);
  };
  const startSaasGoogleAnalytics = (local: ILocal) => {
    if (process.env.REACT_APP_ENVIRONMENT_NAME !== 'development' && process.env.REACT_APP_ENVIRONMENT_NAME !== 'stage') {
      if (local.systemIdentifier === SystemIdentifier.Saas) {
        window.gtag('config', 'G-228WWHWS59');
      }
    }
  }

  const setCurrentCurrency = (currency: { code: string, symbol: string }) => {
    localStorage.setItem(currentCurrencyKey, JSON.stringify(currency));
  };

  const getCurrentCurrency = (): { code: string, symbol: string } | null => {
    try {
      const dataString = localStorage.getItem(currentCurrencyKey);
      if(dataString){
        const response = JSON.parse(dataString) as { code: string, symbol: string };
        return response;
      }else{
        return null
      }
    } catch(error) {
      console.error(error);
      return null
    }
  };

  const removeCurrentCurrency = () => {
    localStorage.removeItem(currentCurrencyKey);
  };

  return {
    setLocals,
    getLocals,
    removeLocals,
    setCurrentLocal,
    getCurrentLocal,
    removeCurrentLocal,
    startSaasGoogleAnalytics,
    setCurrentCurrency,
    getCurrentCurrency,
    removeCurrentCurrency
  };
};


